// ---------------------------------------------- modules import
import M from "materialize-css";
import React, { FunctionComponent, useEffect } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Spinner from "react-spinkit";

import Summary from "./summary";

import { useAuth, usePinnedPosts } from "./hooks";

// ---------------------------------------------- the component
const List: FunctionComponent = () => {
  // ---------------------------------------------- router state
  let match = useRouteMatch();

  // ---------------------------------------------- local state
  const { profile } = useAuth();
  const { pinnedPosts, fetching, error } = usePinnedPosts(profile);

  // ---------------------------------------------- effects
  useEffect(() => {
    const fixedFloatingActionButtons = document.querySelectorAll(
      ".fixed-action-btn"
    );

    M.FloatingActionButton.init(fixedFloatingActionButtons, {
      hoverEnabled: false
    });
  }, []);

  // ---------------------------------------------- content
  return (
    <div className="container">
      <div style={{ paddingLeft: "15px", marginBottom: "10px" }}>
        <span style={{ display: "block", fontSize: "0.75rem" }}>
          pinned posts
        </span>

        <span
          style={{
            display: "inline-block",
            fontSize: "1.75rem",
            fontWeight: 300
          }}
        >
          POSTS FOR YOU...
        </span>
      </div>

      <div className="section row">
        {fetching || error || !pinnedPosts.length
          ? null
          : pinnedPosts.map(pinnedPost =>
              match ? (
                <Link to={`${match.url}/${pinnedPost.id}`} key={pinnedPost.id}>
                  <Summary pinnedPost={pinnedPost} />
                </Link>
              ) : null
            )}
      </div>

      <div
        className={`center-align${error ? " red-text" : ""}`}
        style={{ marginTop: "3rem" }}
      >
        {fetching ? (
          <Spinner name="three-bounce" fadeIn="none" />
        ) : error ? (
          error
        ) : !pinnedPosts.length ? (
          <p className="center-align">No posts found.</p>
        ) : null}
      </div>
    </div>
  );
};

export default List;
